import * as env from "@/utils/env";
import { get, set } from "@/utils/vuex";
import { Storage } from "@/utils/storage";

const storage = Storage.local();

const getInitState = () => ({
	inMobileApp: storage.get("in_mobile_app") || env.isNativeApp(),
	version: {
		web: env.getWebVersion(),
		app: null,
	},
});

export default {
	namespaced: true,
	state: getInitState(),

	getters: {
		inMobileApp: get("inMobileApp"),
	},

	mutations: {
		setInMobileApp(state, value) {
			if (value) storage.set("in_mobile_app", value);
			else storage.remove("in_mobile_app");

			state.inMobileApp = value;
		},

		setVersion: set("version"),
	},

	actions: {
		async init({ state, commit }) {
			const version = {
				...state.version,
				app: await env.getAppVersion(),
			};
			commit("setVersion", version);
			this._vm.$log(
				`Config: App loaded with Web version ${state.version.web} and App version ${state.version.app}`
			);
		},
	},
};
